(ns frontend.test.search.sub
  (:require [clojure.string :as string]
            [common.util :as cu]
            [re-frame.core :as rf]))

(rf/reg-sub
 ::selected
 (fn [db]
   (get db ::selected)))

(rf/reg-sub
 ::search-query
 (fn [db]
   (get db ::search-query)))

(rf/reg-sub
 ::hits
 :<-
 [::search-query]
 (fn [query]
   (->> ["test" "test 2" "test 3"]
        (keep (fn [hit]
                (when (string/starts-with? hit (cu/str-trim-lcase query))
                  {:value hit
                   :label hit}))))))
